import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface SentidoCirculacionPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface SentidoCirculacion {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

/**
 * 🔹 Respuesta genérica
 */
export interface SentidoCirculacionResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class SentidoCirculacionService {
  private readonly apiUrl = `${environment.apiUrl}/api/sentido_circulacion`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getAll(): Observable<SentidoCirculacion[]> {
    return this.http.get<SentidoCirculacion[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  // Obtener por ID
  getById(id: number): Observable<SentidoCirculacion> {
    return this.http.get<SentidoCirculacion>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Crear
  create(
    payload: SentidoCirculacionPayload
  ): Observable<SentidoCirculacionResponse> {
    return this.http.post<SentidoCirculacionResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Actualizar
  update(
    id: number,
    payload: Partial<SentidoCirculacionPayload>
  ): Observable<SentidoCirculacionResponse> {
    return this.http.put<SentidoCirculacionResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Eliminar
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Inactivar
  inactivar(id: number): Observable<SentidoCirculacionResponse> {
    return this.http.put<SentidoCirculacionResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  // Activar
  activar(id: number): Observable<SentidoCirculacionResponse> {
    return this.http.put<SentidoCirculacionResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}